import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { PropsWithChildren } from 'react';
import { useI18nLanguage } from 'shared/hooks';
import { getLocaleByLanguage } from 'shared/i18n';

export default function MuiLocalizationProvider({ children }: PropsWithChildren) {
    const [ i18nLang ] = useI18nLanguage();
    const muiLocale = getLocaleByLanguage(i18nLang);

    return (
        <LocalizationProvider
            dateAdapter={ AdapterDateFns }
            adapterLocale={ muiLocale }
        >
            { children }
        </LocalizationProvider>
    );
}
